import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// Register plugins once for the whole app.
gsap.registerPlugin(ScrollTrigger);

// Shared defaults so every animation in the site feels the same.
gsap.defaults({
    ease: "power3.out",
    duration: 0.9,
});

ScrollTrigger.defaults({
    start: "top 85%",
    toggleActions: "play none none none",
});

// Honour the OS-level "reduce motion" preference: animations still run so
// state ends up correct, but they finish instantly.
const reduceMotionQuery = typeof window !== "undefined" && window.matchMedia
    ? window.matchMedia("(prefers-reduced-motion: reduce)")
    : null;

export function prefersReducedMotion() {
    return Boolean(reduceMotionQuery && reduceMotionQuery.matches);
}

function applyMotionPreference() {
    gsap.globalTimeline.timeScale(prefersReducedMotion() ? 1000 : 1);
}

if (reduceMotionQuery) {
    applyMotionPreference();
    if (typeof reduceMotionQuery.addEventListener === "function") {
        reduceMotionQuery.addEventListener("change", applyMotionPreference);
    }
}

// Re-measure scroll positions once fonts and images have loaded.
if (typeof window !== "undefined") {
    window.addEventListener("load", () => ScrollTrigger.refresh());
}

export { gsap, ScrollTrigger };
